import React from 'react';
import { SellerType } from '@search/filter-enums/enums/SellerType';

import { AuthorBadge } from '../../AuthorBadge/AuthorBadge';

interface SellerSnippetProps {
    seller: {
        name: string;
        sellerType: SellerType;
        organizationName: string;
        icon?: string;
    };
    enableTooltip?: boolean;
    sellerLogoUrl?: string;
}

export const SellerSnippet: React.FC<SellerSnippetProps> = ({ seller, enableTooltip, sellerLogoUrl }) => {
    return (
        <AuthorBadge
            name={seller.name}
            organizationName={seller.organizationName}
            category={seller.sellerType}
            verified={false}
            enableTooltip={enableTooltip}
            sellerLogoUrl={sellerLogoUrl}
        />
    );
};
